import { createSelector } from '@ngrx/store';

import { selectDecoratorsState } from './decorators.selector';
import { DocumentValidationStatus } from '../../../../model';

export const getDocumentValidationStatus = createSelector(
  selectDecoratorsState,
  ({ documentValidationStatus }): DocumentValidationStatus =>
    documentValidationStatus
);
